import { dispatch } from 'store';
import { closeSnackbar, openSnackbar } from 'store/reducers/snackbar';

const Snackbar = (message: string, color: string) => {
  dispatch(
    openSnackbar({
      open: true,
      message,
      variant: 'alert',
      alert: { color: color as 'error' | 'info' | 'success' | 'warning' | 'primary' },
      close: true
    })
  );
  setTimeout(() => {
    dispatch(closeSnackbar());
  }, 3000);
};

export default Snackbar;
